import {
    deviceType,                     // 'mouseOnly' | 'touchOnly' | 'hybrid'
    primaryInput,                   // 'mouse' | 'touch'
    //supportsPointerEvents,
    //supportsTouchEvents,
    //supportsPassiveEvents,
} from 'detect-it';

/**
 * Detect touch device
 * and apply classes hover-start|hover-end
 * for first touch|touch-outside
 * uses https://www.npmjs.com/package/detect-it
 */
export default class Sidemenu {

    constructor() {
        this.sidemenu = document.querySelector('#wah-fixed-menu');

        if( this.sidemenu ) {
            this.init();

            addEventListener("focusin", (event) => {
                if( this.hasFocus(this.sidemenu) ) {
                    this.openSidemenu();
                }
            })

            addEventListener("focusout", (event) => {
                if( ! this.hasFocus(this.sidemenu) ) {
                    this.closeSideMenu();
                }
            })
        }
    }

    init() {
      this.adjustSideMenu();  
      this.checkTouchDevice();
      
    }

    // ------------------------
    // Check if sidemenu has focus inside
    hasFocus(element) {
        return element.contains(document.activeElement);
    }


    // ------------------------
    // Check device
    checkTouchDevice() {
        if( deviceType === 'touchOnly' || primaryInput === 'touch' ) {
            this.setTouchDevice();
        }
        else {
           this.setMouseDevice();
        }
    }

    // ------------------------
    // Adjust for mouse device
    setMouseDevice() {
        this.sidemenu.classList.add('mouse-device');
    }

    // ------------------------
    // Adjust for touch device
    setTouchDevice() {
        this.sidemenu.classList.add('touch-device');
        this.sidemenu.addEventListener('click', this.handleClickSidemenu.bind(this) );
    }


    // ------------------------
    // Move icons out of link
    adjustSideMenu() {
        
        const listItems = this.sidemenu.querySelectorAll('.elementor-icon-list-item');

        listItems.forEach(item => {
            const link = item.querySelector('a');
            if( link !== null ) {
                const icon = item.querySelector('.elementor-icon-list-icon');
                item.insertBefore(icon, link);
            }
        });
    }

    // ------------------------
    // on click side menu
    handleClickSidemenu(e) {
        e.stopPropagation();
        if(!this.sidemenu.classList.contains('hover-start')) {
           this.openSidemenu();
        }
    }

    // ------------------------
    // on click body
    handleBodyClick(e) {
        const clickedOutside = !this.sidemenu.contains(e.target);
        if(clickedOutside) {
            this.closeSideMenu();
        }
    }

    handleScroll(e) {
        this.closeSideMenu();
    }

    // ------------------------
    // open side menu
    openSidemenu() {

        this.sidemenu.classList.add('hover-start');

        // to be able to remove event listener AND bind this
        // https://medium.com/@bigcatplichta/javascript-use-bind-to-dynamically-add-and-remove-event-listeners-d6b443877a73
        this.boundBodyClick = this.handleBodyClick.bind(this);
        document.body.addEventListener('click', this.boundBodyClick );
        this.boundWindowScroll = this.handleScroll.bind(this);
        window.addEventListener('scroll', this.boundWindowScroll);
    }

    // ------------------------
    // close side menu
    closeSideMenu() {

        this.sidemenu.classList.remove('hover-start');
        document.body.removeEventListener('click', this.boundBodyClick );
        window.removeEventListener('scroll', this.boundWindowScroll);
    }
}
